import styled from 'styled-components';

const UserBoxEmail = styled.div`
  font-size: 14px;
  margin-bottom: 15px;
`;

export default UserBoxEmail;
